const store = {
    namespaced: true,
    state() {
        return {
            html: '',
            layout: '',
            show_breadcrumbs: false,
        };
    },
    getters: {
        getContent(state) {
            return {
                html: state.html,
                layout: state.layout,
                show_breadcrumbs: state.show_breadcrumbs,
            };
        },
    },
    mutations: {
        setContent(state, data) {
            state.html = data.html;
            state.layout = data.layout;
            state.show_breadcrumbs = data.show_breadcrumbs;
        },
    },
    actions: {
        async getPage({ commit }, slug) {
            console.log('request', this.$config.TOKEN, 'token');
            return await this.$axios
                .get(`page/${slug}`, {
                    headers: {
                        token: this.$config.TOKEN,
                    },
                })
                .then(async response => {
                    console.log(response, 'htmlData');
                    const htmlData = response.data.objects.find(item => item.html);

                    if (htmlData) {
                        commit('setContent', {
                            html: htmlData.html,
                            layout: htmlData.ignore_layout,
                            show_breadcrumbs: htmlData.show_breadcrumbs,
                        });
                        return {
                            html: htmlData.html,
                            layout: htmlData.ignore_layout,
                            show_breadcrumbs: htmlData.show_breadcrumbs,
                        };
                    }
                })
                .catch(error => {
                    console.log(error, 'error');
                });
        },
    },
};

export default store;
